import { Component, Input } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { defaultSupportEmail } from "../app.component";
import { EventType } from "./ballot.service";

@Component({
    selector: 'app-ballot-error-modal',
    templateUrl: './ballot-error-modal.component.html',
    standalone: false
})
export class BallotErrorModalComponent {
  @Input() isBallotError?: BehaviorSubject<boolean>;
  @Input() error?: BehaviorSubject<string>;
  @Input() ballotType?: EventType;
  @Input() useEmail?: boolean;
  
  supportEmail = defaultSupportEmail;

  constructor() {
    if (this.error) {
      console.error(this.error);
    }
  }

  getError(): string | undefined {
    return this.error?.getValue();
  }

  close(): void {
    if(this.isBallotError) {
      this.isBallotError.next(false);
    }
    else {
      this.isBallotError = new BehaviorSubject<boolean>(false);
    }
  }

}
